jQuery(document).ready(function($) {
    var windowWidth = $(window).outerWidth();

    // Customer statement slider
    var swiper_cst = new Swiper('.swiper-container.cst', {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        speed: 1000,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    // Customer quote slider section
    var swiper_cst_selector = new Swiper('.swiper-container.cst-selector', {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        speed: 1000,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    // Puff slider section
    var swiperPuff = new Swiper('.swiper-container.puff-slider', {
        slidesPerView: 3,
        spaceBetween: 30,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        breakpoints: {
            1440: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // TB slider section
    var swiperTb = new Swiper('.swiper-container.tb-slider', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed: 1000,
        loop: true,
        effect: 'fade',
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

});
